import React, { Component } from "react";
import $ from "jquery";
import moment from "moment";
import config from "../../config/emrok.config";
import { Lightbox } from "react-modal-image";
import UserEdit from "../../assets/images/icons/user-edit.svg";
import UserRemove from "../../assets/images/icons/user-cross.svg";
import DeliveredIcon from "../../assets/images/icons/delivered.svg";
import ProductDelevered from "../../assets/images/icons/delivered.svg";
import InvoiceUpload from "../../assets/images/icons/invoice.svg";

class CustomDatatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      data: [],
      pagination: false,
      selectable: false,
      handleTrackOrderClick: undefined,
      handleEditPatientDetails: undefined,
      handleTrackOrder: undefined,
      downloadPdf: undefined,
      downloadQR: undefined,
      handleEditPatientDetails: undefined,
      handleCancelOrder: undefined,
      handleApproveOrder: undefined,
      pageName: null,
      initialized: false,
      open: false,
      selectedid: "",
      selectedid_delivered: "",
      open_delivered: false,
      handleUploadPrescription: undefined,
      handleEditCallCenter: undefined,
      removeCallCenter: undefined,
      handleEditStockist: undefined,
      editProduct: undefined,
      isViewImage: false,
      handleReorder: false,
      handleDownload: false,
      handleChangeDeliveryStatus: false,
      handleApprovedRXN: false,
      handleEditDoctorPersona: false,
      removeDoctorPersona: false,
      handleUploadInvoice: false,
      handleMarkAsDelivered: false,
      handleRemoveMapping: false
    };
  }

  closeLightbox = () => {
    // this.state.open = true;
    this.setState({ open: false, open_delivered: false });
  };
  openLightBox = (itemid) => {
    //  alert(itemid);
    this.setState({ selectedid: itemid });
    this.setState({ open: true });
    // this.state.open = true;
  };

  openLightBoxDelivered = (itemid) => {
    this.setState({ selectedid_delivered: itemid });
    this.setState({ open_delivered: true });
  }

  static getDerivedStateFromProps(props, state) {
    return {
      columns: props.columns || [],
      data: props.data || [],
      clickType: props.clickType || "",
      pagination: props.hasOwnProperty("pagination") ? props.pagination : false,
      selectable: props.hasOwnProperty("selectable") ? props.selectable : false,
      handleTrackOrderClick: props.handleTrackOrderClick
        ? props.handleTrackOrderClick
        : null,

      handleEditPatientDetails: props.handleEditPatientDetails
        ? props.handleEditPatientDetails
        : null,
      handleCancelOrder: props.handleCancelOrder
        ? props.handleCancelOrder
        : null,
      handleApproveOrder: props.handleApproveOrder
        ? props.handleApproveOrder
        : null,
      handleTrackOrder: props.handleTrackOrder ? props.handleTrackOrder : null,
      downloadPdf: props.downloadPdf ? props.downloadPdf : null,
      downloadQR: props.downloadQR ? props.downloadQR : null,
      handleEditCallCenter: props.handleEditCallCenter
        ? props.handleEditCallCenter
        : null,
      handleUploadPrescription: props.handleUploadPrescription
        ? props.handleUploadPrescription
        : null,
      removeCallCenter: props.removeCallCenter ? props.removeCallCenter : null,
      handleEditStockist: props.handleEditStockist
        ? props.handleEditStockist
        : null,
      pageName: props.pageName ? props.pageName : null,
      editProduct: props.editProduct || undefined,
      handleReorder: props.handleReorder ? props.handleReorder : null,
      handleDownload: props.handleDownload ? props.handleDownload : null,
      handleChangeDeliveryStatus: props.handleChangeDeliveryStatus ? props.handleChangeDeliveryStatus : null,
      handleApprovedRXN: props.handleApprovedRXN ? props.handleApprovedRXN : null,
      handleEditDoctorPersona: props.handleEditDoctorPersona ? props.handleEditDoctorPersona : null,
      removeDoctorPersona: props.removeDoctorPersona ? props.removeDoctorPersona : null,
      handleUploadInvoice: props.handleUploadInvoice ? props.handleUploadInvoice : null,
      handleMarkAsDelivered: props.handleMarkAsDelivered ? props.handleMarkAsDelivered : null,
      handleRemoveMapping: props.handleRemoveMapping ? props.handleRemoveMapping : null
    };
  }

  componentDidMount = () => {
    console.log(this.props.columns, "columns");
    console.log(this.props.data, "data");
    console.log(this.props.clickType, "clickType");

    $("#dt-tbl").DataTable({
      searching: true,
      paging: true,
      aaSorting: [],
      scrollX: true,
      scrollCollapse: true,
      scrollY: "350px",
      // fixedHeader: true,
      buttons: [
        {
          extend: "excel",
          text: "Export to Excel",
          filename: "datatable_export",
          exportOptions: {
            columns: ":visible",
          },
        },
      ],
      drawCallback: () => this.sendPageInfo()
    });

    this.setState({ initialized: true });

    $(".dataTables_wrapper").addClass("parent-data-table-wrap");
  };

  reInitialize = async () => {
    if (this.state.initialized) {
      $("#dt-tbl").DataTable({
        searching: true,
        paging: true,
      });

      this.setState({ initialized: false });
    }
  };

  componentWillUnmount() {
    $("#dt-tbl").DataTable().destroy();
  }

  setImage = (itemid) => {
    this.setState({ selectedid: itemid });
    this.setState({ isViewImage: true });
  }

  getPageInfo = () => {
    let table = $('#dt-tbl').DataTable();
    let currentPage = table.page() + 1
    let rowsPerPage = table.page.len()
    return {
      currentPage,
      rowsPerPage
    }
  }

  sendPageInfo = () => {
    const pageInfo = this.getPageInfo()
    this.props.sendPageInfo && this.props.sendPageInfo(pageInfo)
  }

  render = () => {
    const { columns, data, pagination, selectable, pageName, clickType } = this.props;
    const { initialized, editProduct, isViewImage } = this.state;
    console.log(this.state.isViewImage, "dataall");
    console.log(clickType, "clickTypeprops")
    return (
      <>
        {data.length && columns.length && (
          <table id="dt-tbl" className={`display common-table cell-border common-fixed-coloumn-first ${pageName == "productManagenment" && 'product-management-table-wrap'}`} style={{ width: "100%" }}>
            <thead>
              <tr>
                {columns.map((item, index) => (
                  <th key={`col-${index}`}>{item.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pageName && pageName == "orderhistory"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.order_id}</td>
                    {/* <td>{moment(item.createdAt).format('DD-MM-YYYY')}</td> */}
                    <td>
                      <p style={{ display: "none" }}>
                        {item.createdAt &&
                          moment(item.createdAt).format("YYYY-MM-DD")}
                      </p>
                      {item.createdAt &&
                        moment(item.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td>{item.total_product_qty}</td>
                    <td>
                      ₹
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>Address-{item.address}</td>
                    <td>
                      {/* <button type="button" className="landing-pending-btn"> */}
                      <p className={(item.orderStatus == 'Pending' || item.orderStatus == 'Cancelled') ? `pending-status` : `success-status`}>{item.orderStatus}</p>
                      {/* </button> */}
                    </td>
                    <td>
                      <div className="track-order-btn">
                        <a
                          href="javscript:void(0);"
                          onClick={this.state.handleTrackOrderClick}
                          name={item._id}
                        >
                          {" "}
                          Track Order{" "}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div className="track-order-btn">
                        <a
                          href="javscript:void(0);"
                          onClick={this.state.handleReorder}
                          name={item._id}
                        >
                          {" "}
                          Re Order{" "}
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "orderhistorytracking"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>ID-{item.order_id}</td>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.createdAt &&
                          moment(item.createdAt).format("YYYY-MM-DD")}
                      </p>
                      {item.createdAt &&
                        moment(item.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td>
                      ₹
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>Address-{item.address}</td>
                    <td>
                      <button type="button" className="landing-pending-btn">
                        {item.orderStatus}
                      </button>
                    </td>
                    <td>
                      <div className="track-order-btn">
                        <a
                          href="javscript:void(0);"
                          onClick={this.state.handleTrackOrderClick}
                          name={item._id}
                        >
                          {" "}
                          Track Order{" "}
                        </a>
                      </div>
                    </td>
                    <td>
                      {item.orderStatus == "rejected" ? (
                        <button
                          onClick={this.state.handleUploadPrescription}
                          name={item._id}
                          type="button"
                          className="landing-success-btn"
                        >
                          Upload Prescription
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "mrlanding"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.order_id}</td>
                    <td>{item.doctor_name}</td>
                    <td>{item.stockist_name}</td>
                    <td>{item.customer_state}</td>
                    <td>{item.customer_town}</td>
                    {/* <td>
                                <p>{item.customer_name}</p>
                                <p>Mob-{item.customer_mobile}</p>
                            </td> */}

                    <td>
                      <p style={{ display: "none" }}>
                        {item.order_date &&
                          moment(item.order_date).format("YYYY-MM-DD")}
                      </p>
                      {item.order_date &&
                        moment(item.order_date).format("DD-MM-YYYY")}
                    </td>
                    {/* <td><p style={{ display: 'none' }}>{item.grn_date && moment(item.grn_date).format('YYYY-MM-DD')}</p>{item.grn_date && moment(item.grn_date).format('DD-MM-YYYY')}</td> */}
                    <td>
                      <p style={{ display: "none" }}>
                        {item.delivery_date &&
                          moment(item.delivery_date).format("YYYY-MM-DD")}
                      </p>
                      {item.delivery_date &&
                        moment(item.delivery_date).format("DD-MM-YYYY")}
                    </td>
                    <td>
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>{item.product_code}</td>
                    <td>
                      {
                        <button
                          type="button"
                          className={
                            item.order_status != "complete"
                              ? "landing-pending-btn"
                              : "landing-success-btn"
                          }
                          onClick={this.state.handleTrackOrder}
                          name={item._id}
                        >
                          {item.order_status}
                        </button>
                      }
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "stockistlanding"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.customer_name}</td>
                    <td>{item.order_id}</td>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.order_date &&
                          moment(item.order_date).format("YYYY-MM-DD")}
                      </p>
                      {item.order_date &&
                        moment(item.order_date).format("DD-MM-YYYY")}
                    </td>

                    <td>{item.customer_age}</td>
                    <td>{item.customer_gender}</td>
                    <td>{item.customer_mobile}</td>
                    <td>{item.customer_email}</td>
                    <td>{item.customer_address}</td>
                    <td>{item.customer_city}</td>
                    <td>{item.customer_state}</td>
                    <td>{item.customer_pin}</td>
                    <td>{item.doctor_name}</td>
                    <td>{item.doctor_pin}</td>
                    <td>{item.doctor_registration_no}</td>
                    <td>{item.doctor_mobileno}</td>
                    <td>{item.product_code}</td>
                    <td>{item.total_product_qty}</td>
                    <td>
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>{item.free_pen}</td>
                    <td>{item.payment_status}</td>
                    {/* <td>{item.feedback}</td> */}
                    <td>
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        this.state.open &&
                        this.state.selectedid == item._id && (
                          <Lightbox
                            medium={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            large={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            alt=""
                            onClose={this.closeLightbox}
                          />
                        )}
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        item.prescription_path ? (
                        <img
                          className="prescriptionimage"
                          src={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          onClick={() => this.openLightBox(item._id)}
                        ></img>
                      ) : (
                        ""
                      )}

                      {item.fileExtention != "" &&
                        item.fileExtention == "pdf" ? (
                        <a
                          className="pdffile"
                          href={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          target="_blank"
                        >
                          <i class="fa fa-file-pdf-o"></i>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>    {
                      <a
                        onClick={this.state.downloadPdf}
                        name={item.order_id}
                        id={item.order_id}
                        className="invoicebtn"
                        title="Download Invoice"
                      >
                        <i class="fa fa-download" id={item.order_id} aria-hidden="true"></i>
                      </a>
                    }</td>
                    <td>
                      {
                        item.delivery_date && item.delivery_date != "" ?
                          <>
                            <p style={{ display: "none" }}>
                              {moment(item.delivery_date).format("YYYY-MM-DD")}
                            </p>
                            {moment(item.delivery_date).format("DD-MM-YYYY")}
                          </> : <p></p>
                      }
                    </td>
                    <td>{item.remark}</td>
                    <td>
                      {
                        <button
                          type="button"
                          className={
                            item.order_status != "complete"
                              ? "landing-pending-btn"
                              : "landing-success-btn"
                          }
                          onClick={this.state.handleTrackOrder}
                          name={item._id}
                          title="Track Order"
                        >
                          {item.order_status.charAt(0).toUpperCase() + item.order_status.slice(1)}
                        </button>
                      }
                    </td>
                    <td>
                      <div className="d-flex gap-2 justify-content-center">
                        {item.order_status != 'Cancelled' ? (
                          <a
                            className="bg-order-status-btn cursor_change"
                            onClick={this.state.handleMarkAsDelivered}
                            name={item.order_id}
                            title="Change Order Status"
                            style={{ width: '27px', height: '27px' }}
                          >
                            <img
                              id={item.order_id} src="/assets/icons/order_status_change.png" style={{ height: 18 }} alt="" />
                          </a>
                        ) : (
                          item.order_status == 'delivered' ?
                            <div style={{ display: 'flex' }}>
                              {/* <b>Delivered</b> */}

                              <div style={{ marginLeft: '5px' }} >
                                {item.markAsDeliveredFilePath_extension != "" &&
                                  item.markAsDeliveredFilePath_extension != "pdf" &&
                                  this.state.open_delivered &&
                                  this.state.selectedid_delivered == item._id && (
                                    <Lightbox
                                      medium={
                                        config.serviceUrl +
                                        "/images/MarkAsDelivered/" +
                                        item.markAsDeliveredFilePath
                                      }
                                      large={
                                        config.serviceUrl +
                                        "/images/MarkAsDelivered/" +
                                        item.markAsDeliveredFilePath
                                      }
                                      alt=""
                                      onClose={this.closeLightbox}
                                    />
                                  )}

                                {item.markAsDeliveredFilePath_extension != "" &&
                                  item.markAsDeliveredFilePath_extension != "pdf" &&
                                  item.markAsDeliveredFilePath ? (

                                  <button
                                    type="button"
                                    className="download-btn cursor_change"
                                    // onClick={this.state.handleEditPatientDetails}
                                    id={item._id}
                                    title="Proof Of Delivery"
                                    style={{ marginRight: '5px', marginLeft: '2px' }}
                                  >
                                    <img
                                      className="prescriptionimage"
                                      src="/assets/icons/check-regular-1.png"
                                      onClick={() => this.openLightBoxDelivered(item._id)}
                                      id={item._id}
                                      title="Proof Of Delivery"
                                    ></img>


                                  </button>


                                ) : (
                                  ""
                                )}

                                {item.markAsDeliveredFilePath != "" && item.markAsDeliveredFilePath_extension != null &&
                                  item.markAsDeliveredFilePath_extension == "pdf" ? (
                                  <a
                                    type="button"
                                    className="download-btn cursor_change"
                                    href={
                                      config.serviceUrl +
                                      "/images/MarkAsDelivered/" +
                                      item.markAsDeliveredFilePath
                                    }
                                    target="_blank"
                                    style={{ marginRight: '5px', marginLeft: '2px' }}
                                  >
                                    {/* <i class="fa fa-file-pdf-o"></i> */}
                                    <img
                                      className="prescriptionimage"
                                      src="/assets/icons/check-regular-1.png"
                                      // onClick={() => this.openLightBoxDelivered(item._id)}
                                      // id={item._id}
                                      title="View POD"
                                    ></img>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            :
                            ""
                        )}

                        {item.is_prescription_approved == null && item.order_status != 'delivered' ? (
                          <a
                            className="delivered-btn cursor_change"
                            onClick={this.state.handleApprovedRXN}
                            name={item.order_id}
                            title="Approve RXN"
                            style={{ height: "26px", width: "26px" }}
                          >
                            <img
                              id={item.order_id} src={ProductDelevered} style={{ height: 20 }} alt="" />
                          </a>
                        ) : ""}

                        {item.order_status != 'delivered' && !item.invoice && item.isUploadInvoice == 'yes' ?
                          <a
                            className="delivered-btn cursor_change"
                            onClick={this.state.handleUploadInvoice}
                            name={item.order_id}
                            title="Upload Invoice"
                            style={{ height: "27px", width: "27px" }}
                          >
                            <img
                              id={item.order_id} src={InvoiceUpload} style={{ height: 18 }} alt="" />
                          </a> : ""}


                      </div>
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "callcenterlanding"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.order_id}</td>
                    <td>
                      {" "}
                      <p>{item.customer_name}</p>
                    </td>

                    <td>{item.mr_name}</td>
                    <td>{item.doctor_name}</td>
                    <td>{item.stockist_name}</td>
                    <td>{item.customer_state}</td>
                    <td>{item.customer_city}</td>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.order_date &&
                          moment(item.order_date).format("YYYY-MM-DD")}
                      </p>
                      {item.order_date &&
                        moment(item.order_date).format("DD-MM-YYYY")}
                    </td>
                    {/* <td>{item.order_date && item.order_date && moment(item.order_date).format('DD-MM-YYYY')}</td> */}
                    {/* <td>{item.order_date && moment(item.order_date).format('YYYY-MM-DD')}-{item.order_date && moment(item.order_date).format('DD-MM-YYYY')}</td> */}
                    <td>{item.product_code}</td>
                    <td>{item.total_product_qty}</td>
                    <td>
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>
                      {item.payment_type == "cod" ? "COD" : item.payment_status}
                    </td>
                    <td>{item.feedback}</td>
                    <td>
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        this.state.open &&
                        this.state.selectedid == item._id && (
                          <Lightbox
                            medium={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            large={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            alt=""
                            onClose={this.closeLightbox}
                          />
                        )}
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        item.prescription_path ? (
                        <img
                          className="prescriptionimage"
                          src={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          onClick={() => this.openLightBox(item._id)}
                        ></img>
                      ) : (
                        ""
                      )}

                      {item.fileExtention != "" &&
                        item.fileExtention == "pdf" ? (
                        <a
                          className="pdffile"
                          href={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          target="_blank"
                        >
                          <i class="fa fa-file-pdf-o"></i>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>

                    <td>
                      {
                        <button
                          type="button"
                          className={
                            item.order_status != "complete"
                              ? "landing-pending-btn"
                              : "landing-success-btn"
                          }
                          onClick={this.state.handleTrackOrder}
                          name={item._id}
                        >
                          {item.order_status}
                        </button>
                      }
                    </td>
                    <td>
                      <div className="d-flex">
                        {
                          <button
                            type="button"
                            className="landing-success-btn"
                            onClick={this.state.handleEditPatientDetails}
                            name={item.customer_id}
                          >
                            Edit
                          </button>
                        }
                        {item.order_status == "pending" ? (
                          <button
                            type="button"
                            className="landing-success-btn bg-danger ms-3"
                            onClick={this.state.handleCancelOrder}
                            name={item._id}
                            id={item.customer_mobile}
                            data-bs-target="#orderCanceledModal"
                            data-bs-toggle="modal"
                          >
                            Reject
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                ))
                : null}

              {
                pageName && pageName == "adminlanding" && clickType == ''
                  ? data.map((item, index) => (
                    <tr key={`body-${index}`}>
                      <td>{item.customer_name}</td>
                      <td>
                        <p style={{ display: "none" }}>
                          {item.registration_date &&
                            moment(item.registration_date).format("YYYY-MM-DD")}
                        </p>
                        {item.registration_date &&
                          moment(item.registration_date).format("DD-MM-YYYY")}
                      </td>
                      <td>{item.order_id}</td>
                      <td>
                        <p style={{ display: "none" }}>
                          {item.order_date &&
                            moment(item.order_date).format("YYYY-MM-DD")}
                        </p>
                        {item.order_date &&
                          moment(item.order_date).format("DD-MM-YYYY")}
                      </td>

                      {/* <td>{item.registration_no}</td> */}


                      <td>{item.customer_age}</td>
                      <td>{item.customer_gender}</td>
                      <td>{item.customer_mobile}</td>
                      <td>{item.customer_email}</td>
                      <td>{item.customer_address}</td>
                      <td>{item.customer_city}</td>
                      <td>{item.customer_state}</td>
                      <td>{item.customer_pin}</td>
                      <td>{item.doctor_name}</td>
                      <td>{item.doctor_pin}</td>
                      <td>{item.doctor_registration_no}</td>
                      <td>{item.doctor_mobileno}</td>
                      <td>{item.product_code}</td>
                      <td>{item.total_product_qty}</td>
                      <td>
                        {item.total
                          ? parseFloat(item.total).toFixed(2)
                          : item.total}
                      </td>
                      <td>{item.free_pen}</td>
                      <td>{item.stockist_name}</td>
                      <td>{item.stockist_code}</td>
                      <td>{item.payment_status}</td>
                      {/* <td>{item.feedback}</td> */}
                      <td>
                        {item.fileExtention != "" &&
                          item.fileExtention != "pdf" &&
                          this.state.open &&
                          this.state.selectedid == item._id && (
                            <Lightbox
                              medium={
                                config.serviceUrl +
                                "/images/" +
                                item.prescription_path
                              }
                              large={
                                config.serviceUrl +
                                "/images/" +
                                item.prescription_path
                              }
                              alt=""
                              onClose={this.closeLightbox}
                            />
                          )}
                        {item.fileExtention != "" &&
                          item.fileExtention != "pdf" &&
                          item.prescription_path ? (
                          <img
                            className="prescriptionimage"
                            src={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            onClick={() => this.openLightBox(item._id)}
                          ></img>
                        ) : (
                          ""
                        )}

                        {item.fileExtention != "" &&
                          item.fileExtention == "pdf" ? (
                          <a
                            className="pdffile"
                            href={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            target="_blank"
                          >
                            <i class="fa fa-file-pdf-o"></i>
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                      <td>    {
                        <a
                          onClick={this.state.handleDownload}
                          name={item.order_id}
                          id={item.order_id}
                          className="invoicebtn"
                          title="Download Invoice"
                        >
                          <i class="fa fa-download" id={item.order_id} aria-hidden="true"></i>
                        </a>
                      }</td>
                      <td>
                        {
                          item.delivery_date && item.delivery_date != "" ?
                            <>
                              <p style={{ display: "none" }}>
                                {moment(item.delivery_date).format("YYYY-MM-DD")}
                              </p>
                              {moment(item.delivery_date).format("DD-MM-YYYY")}
                            </> : <p></p>
                        }
                      </td>
                      <td>
                        {item.remark}
                      </td>
                      {/* <td>{item.order_status}</td> */}
                      <td>
                        {
                          <button
                            type="button"
                            className={
                              item.order_status != "complete"
                                ? "landing-pending-btn"
                                : "landing-success-btn"
                            }
                            onClick={this.state.handleTrackOrder}
                            name={item._id}
                            title="Track Order"
                          >
                            {item.order_status ? (item.order_status.charAt(0).toUpperCase() + item.order_status.slice(1)) : ""}
                          </button>
                        }
                      </td>
                      <td>

                        <div className="d-flex justify-content-center">

                          {/* {item.order_status != 'Cancelled' && (item.is_prescription_approved == null || item.is_prescription_approved == 'yes') ? ( */}
                          <a
                            className="bg-order-status-btn cursor_change"
                            onClick={this.state.handleMarkAsDelivered}
                            name={item.order_id}
                            title="Change Order Status"
                            style={{ width: '27px', height: '27px' }}
                          >
                            <img
                              id={item.order_id} src="/assets/icons/order_status_change.png" style={{ height: 18 }} alt="" />
                          </a>

                          {item.order_status == 'delivered' ?
                            <div style={{ display: 'flex' }}>
                              {/* <b>Delivered</b> */}

                              <div style={{ marginLeft: '5px' }} >
                                {item.markAsDeliveredFilePath_extension != "" &&
                                  item.markAsDeliveredFilePath_extension != "pdf" &&
                                  this.state.open_delivered &&
                                  this.state.selectedid_delivered == item._id && (
                                    <Lightbox
                                      medium={
                                        config.serviceUrl +
                                        "/images/MarkAsDelivered/" +
                                        item.markAsDeliveredFilePath
                                      }
                                      large={
                                        config.serviceUrl +
                                        "/images/MarkAsDelivered/" +
                                        item.markAsDeliveredFilePath
                                      }
                                      alt=""
                                      onClose={this.closeLightbox}
                                    />
                                  )}

                                {item.markAsDeliveredFilePath_extension != "" &&
                                  item.markAsDeliveredFilePath_extension != "pdf" &&
                                  item.markAsDeliveredFilePath ? (

                                  <button
                                    type="button"
                                    className="download-btn cursor_change"
                                    // onClick={this.state.handleEditPatientDetails}
                                    id={item._id}
                                    title="Proof Of Delivery"
                                    style={{ marginRight: '5px', marginLeft: '2px' }}
                                  >
                                    <img
                                      className="prescriptionimage"
                                      src="/assets/icons/check-regular-1.png"
                                      onClick={() => this.openLightBoxDelivered(item._id)}
                                      id={item._id}
                                      title="Proof Of Delivery"
                                    ></img>


                                  </button>


                                ) : (
                                  ""
                                )}

                                {item.markAsDeliveredFilePath != "" && item.markAsDeliveredFilePath_extension != null &&
                                  item.markAsDeliveredFilePath_extension == "pdf" ? (
                                  <a
                                    type="button"
                                    className="download-btn cursor_change"
                                    href={
                                      config.serviceUrl +
                                      "/images/MarkAsDelivered/" +
                                      item.markAsDeliveredFilePath
                                    }
                                    target="_blank"
                                    style={{ marginRight: '5px', marginLeft: '2px' }}
                                  >
                                    {/* <i class="fa fa-file-pdf-o"></i> */}
                                    <img
                                      className="prescriptionimage"
                                      src="/assets/icons/check-regular-1.png"
                                      // onClick={() => this.openLightBoxDelivered(item._id)}
                                      // id={item._id}
                                      title="View POD"
                                    ></img>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            :
                            ""}
                          <div className="d-flex justify-content-center">
                            <div className="btn-wrap" style={{ width: 'auto', }}>
                              {
                                <button
                                  type="button"
                                  className="download-btn cursor_change"
                                  onClick={this.state.handleEditPatientDetails}
                                  id={item._id}
                                  title="Edit"
                                  style={{ marginRight: '5px', marginLeft: '2px' }}
                                >
                                  <img
                                    id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                                </button>
                              }

                              {item.is_prescription_approved == null && item.order_status != 'delivered' ? (
                                <a
                                  className="delivered-btn cursor_change"
                                  onClick={this.state.handleApprovedRXN}
                                  name={item.order_id}
                                  title="Approve RXN"
                                  style={{ height: '26px', width: '26px' }}
                                >
                                  <img
                                    id={item.order_id} src={ProductDelevered} style={{ height: 20 }} alt="" />
                                </a>
                              ) : ""}
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                  ))
                  : (
                    pageName && pageName == "adminlanding" && clickType != ''
                      ?
                      data.map((item, index) => (
                        <tr key={`body-${index}`}>
                          <td>
                            <p style={{ display: "none" }}>
                              {item.registration_date &&
                                moment(item.registration_date).format("YYYY-MM-DD")}
                            </p>
                            {item.registration_date &&
                              moment(item.registration_date).format("DD-MM-YYYY")}
                          </td>
                          <td>{item.customer_name}</td>
                          <td>{item.customer_age}</td>
                          <td>{item.customer_gender}</td>
                          <td>{item.customer_mobile}</td>
                          <td>{item.customer_email}</td>
                          <td>{item.customer_address}</td>
                          <td>{item.customer_city}</td>
                          <td>{item.customer_state}</td>
                          <td>{item.customer_pin}</td>
                          <td>{item.doctor_name}</td>
                          <td>{item.doctor_pin}</td>
                          <td>{item.doctor_registration_no}</td>
                          <td>{item.doctor_mobileno}</td>
                          {/* <td>
                            <div className="d-flex justify-content-center">
                              <div className="btn-wrap">
                                {
                                  <button
                                    type="button"
                                    className="download-btn cursor_change"
                                    onClick={this.state.handleEditPatientDetails}
                                    id={item._id}
                                    title="Edit"
                                  >
                                    <img
                                      id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                                  </button>
                                }
                              </div>
                            </div>
                          </td> */}
                        </tr>
                      )) : null

                  )

              }

              {
                pageName && pageName == "callcenterlandingpage" && clickType == ''
                  ? data.map((item, index) => (
                    <tr key={`body-${index}`}>
                      <td>{item.customer_name}</td>
                      <td>
                        <p style={{ display: "none" }}>
                          {item.registration_date &&
                            moment(item.registration_date).format("YYYY-MM-DD")}
                        </p>
                        {item.registration_date &&
                          moment(item.registration_date).format("DD-MM-YYYY")}
                      </td>
                      <td>{item.order_id}</td>
                      <td>
                        <p style={{ display: "none" }}>
                          {item.order_date &&
                            moment(item.order_date).format("YYYY-MM-DD")}
                        </p>
                        {item.order_date &&
                          moment(item.order_date).format("DD-MM-YYYY")}
                      </td>

                      {/* <td>{item.registration_no}</td> */}


                      <td>{item.customer_age}</td>
                      <td>{item.customer_gender}</td>
                      <td>{item.customer_mobile}</td>
                      <td>{item.customer_email}</td>
                      <td>{item.customer_address}</td>
                      <td>{item.customer_city}</td>
                      <td>{item.customer_state}</td>
                      <td>{item.customer_pin}</td>
                      <td>{item.doctor_name}</td>
                      <td>{item.doctor_pin}</td>
                      <td>{item.doctor_registration_no}</td>
                      <td>{item.doctor_mobileno}</td>
                      <td>{item.product_code}</td>
                      <td>{item.total_product_qty}</td>
                      <td>
                        {item.total
                          ? parseFloat(item.total).toFixed(2)
                          : item.total}
                      </td>
                      <td>{item.free_pen}</td>
                      <td>{item.stockist_name}</td>
                      <td>{item.stockist_code}</td>
                      <td>{item.payment_status}</td>
                      {/* <td>{item.feedback}</td> */}
                      <td>
                        {item.fileExtention != "" &&
                          item.fileExtention != "pdf" &&
                          this.state.open &&
                          this.state.selectedid == item._id && (
                            <Lightbox
                              medium={
                                config.serviceUrl +
                                "/images/" +
                                item.prescription_path
                              }
                              large={
                                config.serviceUrl +
                                "/images/" +
                                item.prescription_path
                              }
                              alt=""
                              onClose={this.closeLightbox}
                            />
                          )}
                        {item.fileExtention != "" &&
                          item.fileExtention != "pdf" &&
                          item.prescription_path ? (
                          <img
                            className="prescriptionimage"
                            src={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            onClick={() => this.openLightBox(item._id)}
                          ></img>
                        ) : (
                          ""
                        )}

                        {item.fileExtention != "" &&
                          item.fileExtention == "pdf" ? (
                          <a
                            className="pdffile"
                            href={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            target="_blank"
                          >
                            <i class="fa fa-file-pdf-o"></i>
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                      <td>    {
                        <a
                          onClick={this.state.handleDownload}
                          name={item.order_id}
                          id={item.order_id}
                          className="invoicebtn"
                          title="Download Invoice"
                        >
                          <i class="fa fa-download" id={item.order_id} aria-hidden="true"></i>
                        </a>
                      }</td>
                      <td>
                        {
                          item.delivery_date && item.delivery_date != "" ?
                            <>
                              <p style={{ display: "none" }}>
                                {moment(item.delivery_date).format("YYYY-MM-DD")}
                              </p>
                              {moment(item.delivery_date).format("DD-MM-YYYY")}
                            </> : <p></p>
                        }
                      </td>
                      {/* <td>{item.order_status}</td> */}
                      <td>
                        {
                          <button
                            type="button"
                            className={
                              item.order_status != "complete"
                                ? "landing-pending-btn"
                                : "landing-success-btn"
                            }
                            onClick={this.state.handleTrackOrder}
                            name={item._id}
                            title="Track Order"
                          >
                            {item.order_status.charAt(0).toUpperCase() + item.order_status.slice(1)}
                          </button>
                        }
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <div className="btn-wrap">
                            {
                              <button
                                type="button"
                                className="download-btn cursor_change"
                                onClick={this.state.handleEditPatientDetails}
                                id={item._id}
                                title="Edit"
                              >
                                <img
                                  id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                              </button>
                            }
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                  : (
                    pageName && pageName == "callcenterlandingpage" && clickType != ''
                      ?
                      data.map((item, index) => (
                        <tr key={`body-${index}`}>
                          <td>
                            <p style={{ display: "none" }}>
                              {item.registration_date &&
                                moment(item.registration_date).format("YYYY-MM-DD")}
                            </p>
                            {item.registration_date &&
                              moment(item.registration_date).format("DD-MM-YYYY")}
                          </td>
                          <td>{item.customer_name}</td>
                          <td>{item.customer_age}</td>
                          <td>{item.customer_gender}</td>
                          <td>{item.customer_mobile}</td>
                          <td>{item.customer_email}</td>
                          <td>{item.customer_address}</td>
                          <td>{item.customer_city}</td>
                          <td>{item.customer_state}</td>
                          <td>{item.customer_pin}</td>
                          <td>{item.doctor_name}</td>
                          <td>{item.doctor_pin}</td>
                          <td>{item.doctor_registration_no}</td>
                          <td>{item.doctor_mobileno}</td>
                          {/* <td>
                            <div className="d-flex justify-content-center">
                              <div className="btn-wrap">
                                {
                                  <button
                                    type="button"
                                    className="download-btn cursor_change"
                                    onClick={this.state.handleEditPatientDetails}
                                    id={item._id}
                                    title="Edit"
                                  >
                                    <img
                                      id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                                  </button>
                                }
                              </div>
                            </div>
                          </td> */}
                        </tr>
                      )) : null

                  )

              }



              {pageName && pageName == "customerdetails" && clickType == 'registration'
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.registration_date &&
                          moment(item.registration_date).format("YYYY-MM-DD")}
                      </p>
                      {item.registration_date &&
                        moment(item.registration_date).format("DD-MM-YYYY")}
                    </td>
                    <td>{item.customer_name}</td>
                    <td>{item.customer_age}</td>
                    <td>{item.customer_gender}</td>
                    <td>{item.customer_mobile}</td>
                    <td>{item.customer_email}</td>
                    <td>{item.customer_address}</td>
                    <td>{item.customer_pin}</td>
                    <td>{item.customer_state}</td>
                    <td>{item.customer_city}</td>
                    <td>{item.doctor_name}</td>
                    <td>{item.doctor_pin}</td>
                    <td>{item.doctor_registration_no}</td>
                    <td>{item.doctor_mobileno}</td>


                  </tr>
                ))
                : null}



              {pageName && pageName == "doctorlanding"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.customer_name}</td>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.registration_date &&
                          moment(item.registration_date).format("YYYY-MM-DD")}
                      </p>
                      {item.registration_date &&
                        moment(item.registration_date).format("DD-MM-YYYY")}
                    </td>
                    <td>{item.order_id}</td>
                    <td>
                      <p style={{ display: "none" }}>
                        {item.order_date &&
                          moment(item.order_date).format("YYYY-MM-DD")}
                      </p>
                      {item.order_date &&
                        moment(item.order_date).format("DD-MM-YYYY")}
                    </td>

                    {/* <td>{item.registration_no}</td> */}


                    <td>{item.customer_age}</td>
                    <td>{item.customer_gender}</td>
                    <td>{item.customer_mobile}</td>
                    <td>{item.customer_email}</td>
                    <td>{item.customer_address}</td>
                    <td>{item.customer_city}</td>
                    <td>{item.customer_state}</td>
                    <td>{item.customer_pin}</td>
                    <td>{item.doctor_name}</td>
                    <td>{item.doctor_pin}</td>
                    <td>{item.doctor_registration_no}</td>
                    <td>{item.doctor_mobileno}</td>
                    <td>{item.product_code}</td>
                    <td>{item.total_product_qty}</td>
                    <td>
                      {item.total
                        ? parseFloat(item.total).toFixed(2)
                        : item.total}
                    </td>
                    <td>{item.free_pen}</td>
                    <td>{item.stockist_name}</td>
                    <td>{item.stockist_code}</td>
                    <td>{item.payment_status}</td>
                    {/* <td>{item.feedback}</td> */}
                    <td>
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        this.state.open &&
                        this.state.selectedid == item._id && (
                          <Lightbox
                            medium={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            large={
                              config.serviceUrl +
                              "/images/" +
                              item.prescription_path
                            }
                            alt=""
                            onClose={this.closeLightbox}
                          />
                        )}
                      {item.fileExtention != "" &&
                        item.fileExtention != "pdf" &&
                        item.prescription_path ? (
                        <img
                          className="prescriptionimage"
                          src={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          onClick={() => this.openLightBox(item._id)}
                        ></img>
                      ) : (
                        ""
                      )}

                      {item.fileExtention != "" &&
                        item.fileExtention == "pdf" ? (
                        <a
                          className="pdffile"
                          href={
                            config.serviceUrl +
                            "/images/" +
                            item.prescription_path
                          }
                          target="_blank"
                        >
                          <i class="fa fa-file-pdf-o"></i>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>    {
                      <a
                        onClick={this.state.handleDownload}
                        name={item.order_id}
                        id={item.order_id}
                        className="invoicebtn"
                        title="Download Invoice"
                      >
                        <i class="fa fa-download" id={item.order_id} aria-hidden="true"></i>
                      </a>
                    }</td>
                    <td>
                      {
                        item.delivery_date && item.delivery_date != "" ?
                          <>
                            <p style={{ display: "none" }}>
                              {moment(item.delivery_date).format("YYYY-MM-DD")}
                            </p>
                            {moment(item.delivery_date).format("DD-MM-YYYY")}
                          </> : <p></p>
                      }
                    </td>
                    {/* <td>{item.order_status}</td> */}
                    <td>
                      {
                        <button
                          type="button"
                          className={
                            item.order_status != "complete"
                              ? "landing-pending-btn"
                              : "landing-success-btn"
                          }
                          onClick={this.state.handleTrackOrder}
                          name={item._id}
                          title="Track Order"
                        >
                          {item.order_status.charAt(0).toUpperCase() + item.order_status.slice(1)}
                        </button>
                      }
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <div className="btn-wrap">
                          {
                            <button
                              type="button"
                              className="download-btn cursor_change"
                              onClick={this.state.handleEditPatientDetails}
                              id={item._id}
                              title="Edit"
                            >
                              <img
                                id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "qrcodegeneration"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.doctor_name}</td>
                    <td>{item.doctor_code}</td>
                    <td>{item.state}</td>
                    <td>
                      {
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={this.state.downloadQR}
                          id={item._id}
                        >
                          Download QR Code
                        </button>
                      }
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "callcentermanagment"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.mobileno}</td>
                    <td className='text-center'><p className={item.status == 'INACTIVE' ? 'inactive_status' : 'active_status'}>{item.status}</p></td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <div className="btn-wrap">
                          {
                            <button
                              type="button"
                              className="download-btn cursor_change"
                              onClick={this.state.handleEditCallCenter}
                              id={item._id}
                              title="Edit"
                            >
                              <img
                                id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                            </button>
                          }
                          {
                            <button
                              type="button"
                              className="download-btn cursor_change"
                              onClick={this.state.removeCallCenter}
                              id={item._id}
                              title="Delete"
                            >
                              <img
                                id={item._id} src={UserRemove} style={{ height: 15, width: 15 }} alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
                : null}
              {pageName && pageName == "doctor_persona_managment"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.mobileno}</td>
                    <td className='text-center'><p className={item.status == 'INACTIVE' ? 'inactive_status' : 'active_status'}>{item.status}</p></td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <div className="btn-wrap">
                          {
                            <button
                              type="button"
                              className="download-btn cursor_change"
                              onClick={this.state.handleEditDoctorPersona}
                              id={item._id}
                              title="Edit"
                            >
                              <img
                                id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                            </button>
                          }
                          {
                            <button
                              type="button"
                              className="download-btn cursor_change"
                              onClick={this.state.removeDoctorPersona}
                              id={item._id}
                              title="Delete"
                            >
                              <img
                                id={item._id} src={UserRemove} style={{ height: 15, width: 15 }} alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
                : null}



              {pageName && pageName == "stockistmanagment"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.name}</td>
                    <td>{item.stockist_code}</td>

                    <td>{item.mobileno}</td>
                    <td>{item.email}</td>
                    <td>{item.statecodes}</td>
                    <td>{item.statenames}</td>
                    {/* <td>
                      <div className="d-flex">
                        {
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.state.handleEditStockist}
                            id={item._id}
                          >
                            Edit
                          </button>
                        }
                       
                      </div>
                    </td> */}
                  </tr>
                ))
                : null}
              {pageName && pageName == "productManagenment"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.name}</td>
                    {/* <td>{item.description}</td> */}
                    <td>{item.material}</td>
                    <td>{item.price}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {
                        isViewImage && this.state.selectedid == item._id && (
                          <Lightbox
                            medium={`${config.serviceUrl}/images/${item.poduct_img !== "" ? item.poduct_img : "product_img/no-image.png"}`}
                            large={`${config.serviceUrl}/images/${item.poduct_img !== "" ? item.poduct_img : "product_img/no-image.png"}`}
                            small={`${config.serviceUrl}/images/${item.poduct_img !== "" ? item.poduct_img : "product_img/no-image.png"}`}
                            alt=""
                            onClose={() => this.setState({ isViewImage: false })}
                          />
                        )
                      }
                      {
                        <img
                          className="prescriptionimage"
                          src={`${config.serviceUrl}/images/${item.poduct_img !== "" ? item.poduct_img : "product_img/no-image.png"}?time=${(new Date()).getTime()}`}
                          onClick={() => this.setImage(item._id)}
                        ></img>
                      }
                    </td>
                    <td><p className={item.status == 'INACTIVE' ? 'inactive_status' : 'active_status'}>{item.status}</p></td>
                    <td>
                      <div className="d-flex justify-content-center">
                        {
                          <button
                            type="button"
                            className="download-btn"
                            onClick={() =>
                              editProduct ? editProduct(item) : null
                            }
                            id={item.material}
                            title="Edit"
                          >
                            <img
                              id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                ))
                : null}
              {pageName && pageName == "admin_user_managment"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td className='text-center'>{item.name}</td>
                    <td className='text-center'>{item.email}</td>
                    <td className='text-center'>{item.mobileno}</td>
                    <td className='text-center'><p className={item.status == 'INACTIVE' ? 'inactive_status' : 'active_status'}>{item.status}</p></td>
                    <td className='text-center'>
                      <div className="d-flex justify-content-center">
                        {
                          <a
                            href={void (0)}
                            className="download-btn cursor_change"
                            onClick={this.state.handleEditCallCenter}
                            id={item._id}
                            title="Edit"
                          >
                            <img
                              id={item._id} src={UserEdit} style={{ height: 15, width: 15 }} alt="" />
                          </a>
                        }

                      </div>
                    </td>
                  </tr>
                ))
                : null}

              {pageName && pageName == "stockist_state_mapping"
                ? data.map((item, index) => (
                  <tr key={`body-${index}`}>
                    <td>{item.stockist_name}</td>
                    <td>{item.stockist_code}</td>
                    <td>{item.states}</td>
                    <td>
                      {
                        <a

                          onClick={this.state.handleRemoveMapping}
                          id={item._id}
                        >
                          <img
                            id={item._id} src="/assets/icons/delete.png" style={{ height: 16, width: 15, cursor: 'pointer' }} alt="" />
                        </a>
                      }
                    </td>
                  </tr>
                ))
                : null}


            </tbody>
          </table>
        )
        }
      </>
    );
  };
}

export default CustomDatatable;
